<template>
<b-modal
    has-modal-card
    :active.sync="_active"
    :canCancel="['escape', 'outside', 'x']"
    @close="$emit('close')"
>
    <div class="message-modal-wrapper">
        <slot></slot>
        <span v-text="text" />
        <span v-html="html" />
        <button @click="btnClicked">
            {{ _btnText }}
        </button>
    </div>
</b-modal>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
        },
        html: {
            type: String
        },
        active: {
            type: Boolean,
            default: false,
        },
        btnText: {
            type: String,
        },
        cb: {
            type: Function,
            default: R.always(undefined),
        },
    },
    computed: {
        _active: {
            get: R.prop('active'),
            set(value) {
                this.$emit('update:active', value);
            },
        },
        _btnText() {
            return this.btnText || this.$t('COMMON.close');
        },
    },
    methods: {
        btnClicked() {
            this._active = false;
            this.$emit('btnClicked');
            this.cb();
        },
    },
};
</script>

<style lang="scss" scoped>
.message-modal-wrapper {
    width: 450px;
    border-radius: 10px;
    padding: 30px 15px 15px 15px;
    display: flex;
    flex-direction: column;
    background-color: white;
    position: relative;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    transform: translateY(-3%);

    span:first-child {
        white-space: pre-line;
    }

    button {
        margin-top: 30px;
        background-color: $color21;
        font-size: 18px;
        font-family: $font-common;
        font-weight: bold;
        color: white;
        border-radius: 5px;
        height: 50px;
    }

    span {
        text-align: center;
        font-family: $font-common;
        font-size: 16px;
        color: $color12;
    }
}

@media screen and (max-width: 800px) {
    .message-modal-wrapper {
        width: 90%;
        margin: auto;
    }
}
</style>

<style lang="scss">
.message-modal-wrapper {
    span {
        a:hover {
            color: $color21;
        }
    }
}
</style>







